import type { IconDefinition } from '@vrplatform/icons';

export const QUICK_SEARCH_TABS = [
  { value: 'all', label: 'All', icon: 'SearchIcon' },
  { value: 'owners', label: 'Owners', icon: 'UserIcon' },
  { value: 'listings', label: 'Listings', icon: 'HomeIcon' },
  { value: 'reservations', label: 'Reservations', icon: 'CalendarEventIcon' },
  { value: 'expenses', label: 'Expenses', icon: 'MinusCircleIcon' },
  { value: 'deposits', label: 'Deposits', icon: 'PlusCircleIcon' },
  { value: 'statements', label: 'Statements', icon: 'ClipboardTextIcon' },
  { value: 'commands', label: 'Commands', icon: 'GearIcon', align: 'right' },
] as const satisfies readonly {
  value: string;
  label: string;
  icon: IconDefinition;
  align?: 'right';
}[];

export type QuickSearchTab = (typeof QUICK_SEARCH_TABS)[number]['value'];
export type QuickSearchResultType = Exclude<QuickSearchTab, 'all' | 'commands'>;
